import { apiFetch } from './client';

export interface MeResponse {
  companyName: string;
  subDomain: string;
  partitionId: string;
}

/** Called once on SPA boot by AuthBoundary. */
export function getMe(): Promise<MeResponse> {
  return apiFetch<MeResponse>('/api/v1/me');
}
